export function isAuthenticated() {
  const token = getToken();
  return token !== null;
}

export function getPassWord() {
  return encodeURI(getCookie("pass"));
}

export function setPasswordCookie(pass) {
  setCookie("pass", pass, 5);
}

export function logOut() {
  deleteCookie("pass");
}

function setCookie(cname, cvalue, hour) {
  const d = new Date();
  d.setTime(d.getTime() + 5 * hour * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function deleteCookie(name) {
  console.log(name);
  document.cookie = "";
}

export function setPasswordLocalStorage(pass) {
  console.log("settinglocalpss", pass);
}

export function getPasswordLocalStorage() {
  return localStorage.getItem("encPass");
}

export function clearPasswordLocalStorage() {
  return localStorage.removeItem("encPass");
}

export function saveAuth(token) {
  if (token !== undefined) saveToLocal("auth", token);
  else window.localStorage.removeItem("auth");
}

export function getAuth() {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth;
  }
  return null;
}

export function saveToLocal(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function getToken() {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth["token"];
  }
  return null;
}

export function getUserDetails() {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth["user"];
  }
  return null;
}

export function getRoleFromLocal() {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth["role"];
  }
  return null;
}

export function getWalletFromLocal() {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth["user"]["app_user"]["wallet"];
  }
  return null;
}

export const isLoginFromSoilApp = () => {
  let authJson = window.localStorage.getItem("auth");
  if (authJson !== null && authJson !== undefined) {
    let auth = JSON.parse(authJson);
    return auth["isLoginFromSoilApp"] === true;
  }
  return false;
};

/**
 * Logs out the current user and restores the parent users's authentication state.
 * For instance, when PoP manager logs in a farmer user and wants to switch back
 * to the PoP manager's view, this function can be used to log out the farmer
 *
 * @param {string} [redirectUrl] - Optional URL to redirect to after logout.
 *                                If not provided, the page will reload.
 */
export function logoutToParent(redirectUrl = null) {
  localStorage.removeItem("auth");

  // Restore auth_backup as current auth
  const authBackup = JSON.parse(localStorage.getItem("auth_backup"));
  if (authBackup) {
    saveAuth(authBackup);
    localStorage.removeItem("auth_backup");
  }

  if (redirectUrl) {
    window.location.href = redirectUrl;
  } else {
    window.location.reload();
  }
}
